import { getToken } from 'hooks/useAuth';
import { apiBaseUrl } from './urls';

export const checkIfIframe = (content: string) => {
  const regex = /<iframe.*?<\/iframe>/i;
  return regex.test(content);
};

export const removeUrlParams = (content: string) => {
  const doc = new DOMParser().parseFromString(content, 'text/html');
  const elements = doc.querySelectorAll('iframe[src]');

  elements.forEach((element: any) => {
    const url = new URL(element.src);
    url.search = '';
    if (element.src) {
      element.src = url.toString();
    }
  });
  const htmlReturnString = doc.documentElement.outerHTML;
  return `<!DOCTYPE html>` + htmlReturnString;
};

// This function is used to add necessary params to the iframe src in order to display the procedure in correct mode in account builder.
export const addParamsToIframeSrc = (content: string) => {
  const params = {
    procedureDisplayType: '2',
  };
  const doc = new DOMParser().parseFromString(content, 'text/html');
  const iframes = doc.querySelectorAll('iframe[src]');

  iframes.forEach((iframe: any) => {
    let src = iframe.getAttribute('src')?.replace(/ /g, '%20');
    if (!src) return;
    src = src.replace(/\/[A-Za-z]+=\w+/g, '');
    const parsed = new URL(src, apiBaseUrl);
    const pathWithoutApiPrefix = parsed.pathname.replace(/^\/api\//, '');
    const url = new URL(pathWithoutApiPrefix, apiBaseUrl);

    Object.entries(params).forEach(([key, value]) => {
      if (!url.searchParams.has(key)) {
        url.searchParams.append(key, value);
      }
    });

    iframe.setAttribute('src', url.toString());
  });

  return doc.documentElement.outerHTML;
};

export const stripAndTrimHTML = (rawHTML: string): string => {
  const div: HTMLDivElement | undefined = document.createElement('div');
  div.innerHTML = rawHTML;
  const plainText = div.textContent || div.innerText || '';
  return plainText.trim();
};
